import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./views/Layout.js";
import Home from "./views/Home.js";
import UG from "./views/UG.js";
import EG from "./views/EG.js";
import FirstFloor from "./views/FirstFloor.js";
import SecondFloor from "./views/SecondFloor.js";
import About from "./views/About.js";
import Disclaimer from "./views/Disclaimer.js";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="campus" element={<Home />} />
            <Route path="UG" element={<UG />} />
            <Route path="EG" element={<EG />} />
            <Route path="first-floor" element={<FirstFloor />} />
            <Route path="second-floor" element={<SecondFloor />} />
            <Route path="about" element={<About />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
